import styled from 'styled-components';
import { Text14Light, Text14Regular } from '../../Text/Text.styles';
import { theme } from '../../../../styles/constants';

export const StyledLabel = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 1.8rem;
  opacity: ${props => (props.disabled ? 0.8 : 1)};

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const StyledInput = styled.input`
  font-size: 1.5rem;
  letter-spacing: -0.15px;
  line-height: normal;
  font-weight: 400;
  color: ${theme.colors.textColor};
  background: ${theme.colors.white};
  height: 4.8rem;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #97c9f1;
  padding: 1.4rem 1.6rem;
  box-shadow: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }

  &::placeholder {
    color: #0b3a5f;
    font-weight: 300;
  }
`;

export const LabelText = styled(Text14Regular)``;

export const PrefixText = styled.span`
  position: absolute;
  left: 0.8rem;
  top: 2.9rem;
  font-size: 1.4rem;
  font-weight: 400;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  width: fit-content;
  margin-bottom: 0.4rem;
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #d8eaf9;
  padding: 1.2rem;
  position: absolute;
  width: 24rem;
  right: 0;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  z-index: 1000;
`;

export const TooltipText = styled(Text14Light)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: -0.408px;
`;
